import { Component, OnInit, Input, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Title } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { lastValueFrom } from "rxjs";
import { Utilities } from "src/app/models/utilities";
import { AppCoreService } from "src/app/services/app-core.service";
import { CompanyService } from "src/app/services/company.service";
import { CustomerService } from "src/app/services/customer.service";
import { RateUploadService } from "src/app/services/operations/rateupload.service";
import { ProductService } from "src/app/services/products.service";
import { RateBandsService } from "src/app/services/ratebands.service";
import { TaxesService } from "src/app/services/system-config/taxes/taxes.service";
import { VendorService } from "src/app/services/vendor.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-edit-taxes',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss'],
})

export class EditTaxesComponent implements OnInit, AfterViewInit {
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  @Input() taxData: any;
  isModelSubmitted = false;

  taxesEditForm: FormGroup;
  Id: number;
  vendorList: any;
  rateCategoryList: any;
  customerList: any;
  rateBandList: any;
  rateCategoriesList: any;
  productList: any[];
  companyList: any[] = [];
  context: any
  rateTypeList: any[] = [];
  showBands = false;
  showCustomer = false;
  showVendor = false;
  formSavedData: any;
  currentDate: any;
  showCategory = false;
  useEnterKey: any;
  constructor(
    private formBuilder: FormBuilder,
    private rateUploadService: RateUploadService,
    private ngxLoaderService: NgxUiLoaderService,
    private utilities: Utilities,
    private appCoreService: AppCoreService,
    private productService: ProductService,
    private rateBandsService: RateBandsService,
    private customerService: CustomerService,
    private companyService: CompanyService,
    private taxesService: TaxesService,
    public activeModal: NgbActiveModal,
    private vendorService: VendorService,
    private titleService: Title
  ) { 
    titleService.setTitle('Taxes');
    this.context = { componentParent: this } 
  }


  async ngOnInit() {
    this.currentDate = this.utilities.FormatDateWithTime();
    this.taxesEditForm = this.formBuilder.group({
      ddlRateType: [{ value: null, disabled: true }, Validators.required],
      ddlRateCategory: [null],
      ddlRateBand: [null],
      ddlCustomer: [null],
      ddlVendor: [null],
      ddlCompany: [null],
      ddlProduct: [null],
      txtIGST: [null, Validators.required],
      txtCGST: [null, Validators.required],
      txtSGST: [null, Validators.required],
      txtFromDate: [{ value: this.currentDate.dateString, disabled: true }, Validators.required],
      txtToDate: [this.currentDate.dateString, Validators.required],
    });
    this.checkPermission();
    await this.getAllRateTypes();
    this.getAllProducts();
    this.getAllCustomers();
    this.getAllCompanies();
    this.getAllRateBands();
    this.getAllProducts();
    this.bindFields(this.taxData);
    this.getAllVendors();
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.taxesEditForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();  
    // this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'Taxes');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindFields(param: any) {
    const cell = param ? this.taxData : param;
    if (cell) {
      this.taxesEditForm.patchValue({
        txtFromDate: this.utilities.FormatDateWithTime(0, cell.fromdate).dateString,
        txtToDate: this.utilities.FormatDateWithTime(0, cell.todate).dateString,
        ddlRateType: cell.ratetypeid,
        ddlRateCategory: cell.ratecategoryid,
        ddlRateBand: cell.ratebandid,
        ddlCustomer: cell.customerid,
        ddlVendor: cell.vendorid,
        ddlProduct: cell.productcode,
        ddlCompany: cell.companyid,
        txtIGST: cell.igst,
        txtCGST: cell.cgst,
        txtSGST: cell.sgst,
      });
      this.Id = cell.id;
      let rateTypeId = this.rateTypeList.length ? this.rateTypeList.find(x => x.id == cell.ratetypeid)?.id : null;
      // // console.log(rateTypeId);
      this.taxesEditForm.get('ddlRateType').setValue(rateTypeId);
      // this.taxesEditForm.get('txtFromDate').setValue(this.utilities.FormatDateWithTime(0, cell.fromdate).dateString);

      // this.taxesEditForm.get('txtToDate').setValue(this.utilities.formatDate(cell.todate, 'mm-dd-yyyy').dateString);
      this.showBands = false;
      this.showCustomer = false;
      this.taxesEditForm.get('ddlRateBand').clearValidators();
      this.taxesEditForm.get('ddlCustomer').clearValidators();
      this.taxesEditForm.get('ddlVendor').clearValidators();
      this.taxesEditForm.get('ddlRateCategory').disable();
      if (cell.ratebandid) {
        // console.log('under rateband');
        this.taxesEditForm.get('ddlRateBand').setValue(cell?.ratebandid);
        this.taxesEditForm.get('ddlCustomer').reset();
        this.showBands = true;
        this.showCustomer = false;
        //set required fields
        this.taxesEditForm.controls.ddlRateBand.setValidators([Validators.required]);
        this.taxesEditForm.controls.ddlCustomer.clearValidators();
        // this.taxesEditForm.get('ddlRateCategory').updateValueAndValidity();
        this.taxesEditForm.get('ddlCustomer').updateValueAndValidity();
        this.taxesEditForm.get('ddlRateBand').updateValueAndValidity();
      }
      else if (cell.customerid) {
        // console.log('under customer');
        this.taxesEditForm.get('ddlCustomer').disable();
        this.taxesEditForm.get('ddlCustomer').setValue(cell?.customerid);
        this.taxesEditForm.get('ddlRateBand').reset();
        this.showCategory = true;
        this.showCustomer = true;
        this.showBands = false;
        this.taxesEditForm.controls.ddlCustomer.setValidators([Validators.required]);
        this.taxesEditForm.controls.ddlRateBand.clearValidators();
        // this.taxesEditForm.get('ddlRateCategory').updateValueAndValidity();
        this.taxesEditForm.get('ddlCustomer').updateValueAndValidity();
        this.taxesEditForm.get('ddlRateBand').updateValueAndValidity();
      } else if(cell.vendorid) {
        // this.taxesEditForm.get('ddlRateCategory').enable();
        this.taxesEditForm.get('ddlVendor').disable();
        this.taxesEditForm.get('ddlVendor').setValue(cell?.vendorid);
        this.taxesEditForm.get('ddlRateBand').reset();
        this.showCategory = true;
        this.showCustomer = false;
        this.showVendor = true;
        this.showBands = false;
        this.taxesEditForm.controls.ddlVendor.setValidators([Validators.required]);
        this.taxesEditForm.controls.ddlRateBand.clearValidators();
        this.taxesEditForm.controls.ddlCustomer.clearValidators();
        // this.taxesEditForm.get('ddlRateCategory').updateValueAndValidity();
        this.taxesEditForm.get('ddlVendor').updateValueAndValidity();
        this.taxesEditForm.get('ddlRateBand').updateValueAndValidity();
        this.taxesEditForm.get('ddlCustomer').updateValueAndValidity();
      }
    }
  }

  updateTaxes() {
    this.isModelSubmitted = true;
    if (!this.permConfig.isEditAllowed) {
      this.warningDialog('No Access to Edit.');
      return;
    }
    const invalidControls = Object.keys(this.taxesEditForm.controls).filter(controlName => this.taxesEditForm.get(controlName)?.invalid);
    if (invalidControls.length > 0) {
      // console.log('Invalid controls:', invalidControls);
      // You can handle the invalid controls here
    } else {
      // console.log('All controls are valid.');
    }
    try {
      if (this.taxesEditForm.valid && this.permConfig.isEditAllowed) {
        const rateTypeId = this.taxesEditForm.get('ddlRateType').value;
        const rateCategoryId = this.taxesEditForm.get('ddlRateCategory').value;
        let requestObj = {
          id: this.Id,
          ratetypeid: rateTypeId,
          ratecategoryid: rateCategoryId,
          ratebandid: this.taxesEditForm.get('ddlRateBand').value,
          fromdate: this.taxesEditForm.get('txtFromDate').value,
          todate: this.taxesEditForm.get('txtToDate').value,
          customerid: this.taxesEditForm.get('ddlCustomer').value,
          vendorid: this.taxesEditForm.get('ddlVendor').value,
          productcode: this.taxesEditForm.get('ddlProduct').value,
          companyid: this.taxesEditForm.get('ddlCompany').value,
          igst: this.taxesEditForm.get('txtIGST').value.toString(),
          cgst: this.taxesEditForm.get('txtCGST').value.toString(),
          sgst: this.taxesEditForm.get('txtSGST').value.toString(),
        };
        this.taxesService.Update(requestObj).subscribe(res => {
          this.ngxLoaderService.start();
          if (res) {
            if (!res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage('This combination already exists !', 'Error', 'error')
            }
            if (res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage('Record Updated Successfully');
              this.activeModal.close('Save Click');
            }
          }
        })
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getAllRateTypes() {
    try {
      const res = await lastValueFrom(this.rateUploadService.GetAllRateTypes());
        if (res && res.success) {
          this.rateTypeList = res.data.types;
          // this.rateCategoriesList = res.data.categories.filter(x => x.ratecategory == 'Customer');
          this.rateCategoriesList = res.data?.categories?.filter(
            (item) => item.ratecategory !== 'Country Rate' && item.ratecategory !== 'Zone Rate'
          ) || [];
        }
    } catch (error) {
      console.error(error);
    }
  }

  getAllProducts() {
    try {
      this.productService.GetAll().subscribe((res) => {
        if (res?.success) {
          this.productList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }

  }

  getAllRateBands() {
    try {
      this.rateBandsService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.rateBandList = res.data;
        }
      })
    } catch (error) {

    }
  }

  getAllCustomers() {
    this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter }).subscribe((res) => {
      if (res) {
        this.customerList = res.data;
      }
    })
  }

  getAllVendors() {
    try {
      this.vendorService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.vendorList = res.data;
        }
      })
    } catch (error) {
      console.error(error);
    }
  }

  getAllCompanies() {
    try {
      this.ngxLoaderService.start();
      this.companyService.GetAll().subscribe((res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.companyList = res.data;
        } else {
          this.ngxLoaderService.stop();
        }
      });
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  async warningDialog(msg?: any) {
    Swal.fire({
      titleText: 'Warning',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

}